"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper
    }
}); });
var Loader = function (props) {
    var isLoading = props.isLoading;
    if (isLoading !== true) {
        return null;
    }
    return (react_1["default"].createElement("p", null,
        react_1["default"].createElement("i", null, "is being updated")));
};
var ListUnit = function (_a) {
    var i = _a.i, value = _a.value, updatePromise = _a.updatePromise;
    var _b = react_1["default"].useState(!!value.assigned), isChecked = _b[0], setChecked = _b[1];
    var _c = react_1["default"].useState(false), isLoading = _c[0], setLoading = _c[1];
    var _d = react_1["default"].useState(value.assigned), assigned = _d[0], setAssigned = _d[1];
    var handleClick = function () {
        if (isLoading === true) {
            console.warn('this action is blocked since the promise is still working');
        }
        setLoading(true);
        updatePromise(value.id, assigned).then(function (x) {
            setChecked(!isChecked);
            setLoading(false);
            setAssigned(Boolean(x));
        });
    };
    var labelId = "checkbox-list-label-" + i;
    return (react_1["default"].createElement(ListItem_1["default"], { key: i, role: undefined, dense: true, button: true, onClick: handleClick },
        react_1["default"].createElement(ListItemIcon_1["default"], null,
            react_1["default"].createElement(Checkbox_1["default"], { edge: "start", checked: isChecked, tabIndex: -1, disableRipple: true, inputProps: { 'aria-labelledby': labelId } })),
        react_1["default"].createElement(ListItemText_1["default"], { id: labelId, primary: value.name }),
        react_1["default"].createElement(Loader, { isLoading: isLoading })));
};
var ListAssign = function (props) {
    var data = props.data, updatePromise = props.updatePromise;
    var classes = useStyles();
    return (react_1["default"].createElement(List_1["default"], { className: classes.root }, data.map(function (value, i) { return (react_1["default"].createElement(ListUnit, { key: i, i: i, value: value, updatePromise: updatePromise })); })));
};
exports["default"] = ListAssign;
